import {ezLoad, saveSession} from "@/sessionSave";
import {addCourse, defaultCourses, remoteGetCourses} from "@/courseProcessor";
import Vue from 'vue'
import ElementUI from 'element-ui';
import VueLocalStorage from 'vue-localstorage'
import Vuex from 'vuex'
import axios from "axios";
import {Merge, Print} from "@/fuckingJSExtension";

Vue.use(VueLocalStorage)
Vue.use(ElementUI);
Vue.use(Vuex)


let vuexState = {
    allCourses: null,
    courseGroups: ezLoad('courseGroups') ?? {'default': defaultCourses()},
    courseGroupsAvailable: ezLoad('courseGroupsAvailable') ?? ['default'],
    usingCourse: ezLoad('usingCourse') ?? 'default',
    timetableOptions: ezLoad('timetableOptions') ?? {
        weekday: '12345'.split(''),
        timeslot: 'ABCDEFGHIJK'.split(''),
        allowCrash: true,
        showOnlySelected: true,
        showAttr: {"teacher": false,},
        previewCourse: null,
        courseDetail: {
            showDetail: false,
            showCourse: null
        }
    },
    user: ezLoad('user') ?? {
        loginInfo: {name: 'anonymous', login: false, code: null, expire: null},
        displayName: '',
        dep: '資訊工程學系',
        grade: '大一',
        hasPressedLike: false,
        hasWatchedRequest: false,
    },
    domain: "https://solrz.github.io/nice-course-to-u/",
    viewState: {
        addingCourseGrid: null,
        hoverCourseGrid: {weekday: null, timeslot: null},
    },
    coursesDiscuss: {},
    coursesExtension: ezLoad('coursesExtension') ?? {}
};
let vuex_mutations = {
    async loadCourses(state) {
        let forceReload = false
        try {
            var allCourses =
                JSON.parse(localStorage.getItem('allCourses'))
        } catch (e) {
            console.log(e)
            // return
        }
        if (forceReload || !allCourses) {
            this._vm.$notify({
                title: '從遠端載入所有課程',
                message: '這可能需要10秒',
                type: 'info'
            });
            allCourses = await remoteGetCourses()
            console.log(allCourses)
            localStorage.setItem('allCourses', JSON.stringify(allCourses))
            this._vm.$notify({
                title: '成功載入遠端課程',
                message: '下次可以直接使用了',
                type: 'success'
            });
        } else {
            // console.log(allCourses)
            console.log("Loaded courses from local")
        }
        state.allCourses = allCourses
        // console.log(Object.keys(state.allCourses))
    },
    updateCourse(state, course) {
        console.log("Adding course")
        state.timetableOptions.previewCourse = null
        state.courseGroups[state.usingCourse] = addCourse(state.courseGroups[state.usingCourse], course)
        saveSession(state)
    },
    async loadSharedCourses(state, params) {
        let rawCoursesID = params.importCoursesID ?? ""
        let coursesID = rawCoursesID.replace(' ', '').split(',')
        console.log(state.allCourses)
        try {
            var allCourses =
                JSON.parse(localStorage.getItem('allCourses'))
        } catch (e) {
            console.log(e)
            // return
        }
        if (!allCourses) {
            allCourses = await remoteGetCourses()
        }
        let importCourseGroup = params.importCourseGroupName ?? "default"
        state.allCourses = allCourses
        state.usingCourse = importCourseGroup
        if (!state.courseGroups[importCourseGroup]) {
            state.courseGroupsAvailable.push(importCourseGroup)
            state.courseGroups[importCourseGroup] = defaultCourses()
        }
        for (const cid of coursesID) {
            if (cid) {
                if (cid.length !== 0) {
                    console.log(cid)
                    Print(`Importing course: ${cid}`)
                    let courses = state.courseGroups[importCourseGroup].list
                    let course = state.allCourses[cid]
                    if (!course) {
                        Print(`Invalid course: ${cid}`)
                        continue
                    }
                    if (!courses.includes(course)) {
                        state.courseGroups[importCourseGroup] = addCourse(state.courseGroups[importCourseGroup], allCourses[cid])
                        Print(`Import done course: ${cid}`)
                    } else {
                        Print(`Course already exist course: ${cid}`)
                    }
                }
            }
        }
        saveSession(state)

    },
    switchCourseGroup(state, groupName) {
        state.usingCourse = groupName
        if (!state.courseGroupsAvailable.includes(groupName)) {
            state.courseGroupsAvailable.push(groupName)
        }
        if (!state.courseGroups[groupName]) {
            state.courseGroups[groupName] = defaultCourses()
        }
        console.log("New Course Group Generated:", groupName)
        saveSession(state)
    },
    async loadDiscuss(state) {
        let timetableLink = "https://script.google.com/macros/s/AKfycbyx59Df4z6K7AlCDwPLjRbKaeJUaVkx53Td-ERiQ3KLS4_IrzVO/exec"
        let resp = await axios.get(timetableLink)
        console.log(resp.data)
        state.coursesDiscuss = resp.data
        saveSession(state)
        return resp.data
    },
    signLoginUser(state, params) {
        state.user.loginInfo.login = true
        state.user.loginInfo.name = params.username
        state.user.loginInfo.code = params.code
        state.user.loginInfo.expire = params.expire
        saveSession(state)
    },
    loadCourseExtension(state, coursesExtension) {
        state.coursesExtension = Merge(state.coursesExtension, coursesExtension)
        // Print(state.coursesExtension)
        saveSession(state)
    }
    // getUserData(state){
    //     axios.get("")
    //     saveSession(state)
    // }
};
export const vuex = new Vuex.Store({
    state: vuexState,
    mutations: vuex_mutations
})
